import { useCallback, useContext, useEffect, useState } from 'react'

import { MapContext } from '@/feature/map/context/map'

/**
 * Switches the map between the roadmap and hybrid-satellite base layers.
 *
 * As with the traffic toggle, the state is held locally so the toggle works uncontrolled, and
 * re-synced whenever a controlled `value` changes.
 */
export const useMapMode = (value: boolean, onValueChange: (value: boolean) => void) => {
  const [useSatellite, setUseSatellite] = useState(value)

  const map = useContext(MapContext)

  useEffect(() => {
    setUseSatellite(value)
  }, [value])

  useEffect(() => {
    map?.map?.setMapTypeId(
      useSatellite ? google.maps.MapTypeId.HYBRID : google.maps.MapTypeId.ROADMAP,
    )
  }, [useSatellite, map?.map])

  const toggleMapMode = useCallback(
    (next: boolean) => {
      setUseSatellite(next)
      onValueChange(next)
    },
    [onValueChange],
  )

  return { useSatellite, toggleMapMode }
}
